import './style.scss';
import {t} from "i18next";
import useUserData from "../../../lib/utils/hooks/useUserData";
import {Input, Label} from "reactstrap";
import {usePublicEndpoints} from "../../../lib/api/usePublicEndpoints";
import {toast} from "react-toastify";
import {useContext, useEffect, useState} from "react";
import {GlobalState} from "../../../lib/api/globalState";

const NotificationsProfile = () => {
    const { updateClient } = usePublicEndpoints();
    const [globalStateValue] = useContext(GlobalState);
    const userData = useUserData();

    const [isSubscribed, setIsSubscribed] = useState(false);

    const handleChange = async (e) => {
        const checked = e.target.checked;
        try {
            await updateClient(globalStateValue.userId, {
                unsubscribed_news: !checked,
            })
            setIsSubscribed(checked);
        } catch (error) {
            toast(error.message, {type: 'error'})
        }
    };

    useEffect(() => {
        setIsSubscribed(!userData.unsubscribed_news);
    }, [userData])

    return (
        <>
            <h1 className='profile-title'>{t('profile.notifications.blockTitle')}</h1>

            {Object.keys(userData).length > 0 &&
                <div className="checkout__input-wrapper notification-profile radio-input">
                    <Input
                        type="checkbox"
                        id="unsubscribed_news"
                        name="unsubscribed_news"
                        checked={isSubscribed}
                        onChange={handleChange}
                    />
                    <Label htmlFor="unsubscribed_news" className="offer-label checkout__lable">
                        {t('profile.notifications.newsletterConsent')}
                    </Label>
                </div>
            }
        </>
    )
}

export default NotificationsProfile;